export default __webpack_public_path__ + "static/media/Dhwaj.49d1002b.jpg";